import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RoleEnum } from "../../enums/role.enum";
import { GenderEnum } from "../../enums/gender.enum";
import { Company } from "../../features/companies/types/api/get-company-success-response";

export type User = {
    id: number;
    email: string;
    name: string;
    role: RoleEnum;
    gender: GenderEnum;
    uniqueId: string;
    employmentDate: number;
    company?: Company;
    created: number;
    modified: number;
};

type SessionState = {
    user: User | null;
};

const initialState: SessionState = {
    user: null
};

export const sessionSlice = createSlice({
    name: 'session',
    initialState,
    reducers: {
        setMe: (state, action: PayloadAction<{ user: User }>) => {
            state.user = action.payload.user;
        },
        login: (state, action: PayloadAction<{ user: User, rememberMe: boolean; accessToken: string }>) => {
            state.user = action.payload.user;
            localStorage.setItem('AccessToken', action.payload.accessToken);
            if (action.payload.rememberMe === true) localStorage.setItem('RememberMe', '1');
        },
        logout: (state) => {
            state.user = null;
            localStorage.removeItem('AccessToken');
            localStorage.removeItem('RememberMe');
        }
    }
});

export const {
    setMe,
    login,
    logout
} = sessionSlice.actions;